import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { PayrollConcept } from '../entities/payroll-concept';

@Injectable()
export class PayrollConceptService extends BaseCrudService<PayrollConcept> {

  public uri = '/api/payrollConcept/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance PayrollConceptService');
  }

  buildSentence(entity?: PayrollConcept, event?: LazyLoadEvent): HttpParams {
    this.httpParams = new HttpParams();
    if (entity) {
      let query = '';
      query = query.concat(
        entity.code ?
          `code${QueryOperator.Contain}${entity.code}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.name ?
          `name${QueryOperator.Contain}${entity.name}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.abbreviation ?
          `abbreviation${QueryOperator.Contain}${entity.abbreviation}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.sign ?
          `sign${QueryOperator.Contain}${entity.sign}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.person ?
          `person${QueryOperator.Contain}${entity.person}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.fiscalYear && entity.fiscalYear.id) {
        query = query.concat(
          `fiscalYear.id${QueryOperator.Equal}${entity.fiscalYear.id}${QueryOperator.Split}`
        );
      }
      if (entity.executingUnit && entity.executingUnit.id) {
        query = query.concat(
          `executingUnit.id${QueryOperator.Equal}${entity.executingUnit.id}${QueryOperator.Split}`
        );
      }
      if (entity.plameConcept && entity.plameConcept.id) {
        query = query.concat(
          `plameConcept.id${QueryOperator.Equal}${entity.plameConcept.id}${QueryOperator.Split}`
        );
      }
      if (entity.mcppConcept && entity.mcppConcept.id) {
        query = query.concat(
          `mcppConcept.id${QueryOperator.Equal}${entity.mcppConcept.id}${QueryOperator.Split}`
        );
      }
      if (entity.generalLedgerCredit && entity.generalLedgerCredit.id) {
        query = query.concat(
          `generalLedgerCredit.id${QueryOperator.Equal}${entity.generalLedgerCredit.id}${QueryOperator.Split}`
        );
      }
      if (entity.generalLedgerDebit && entity.generalLedgerDebit.id) {
        query = query.concat(
          `generalLedgerDebit.id${QueryOperator.Equal}${entity.generalLedgerDebit.id}${QueryOperator.Split}`
        );
      }
      if (entity.identifier && entity.identifier.id) {
        query = query.concat(
          `identifier.id${QueryOperator.Equal}${entity.identifier.id}${QueryOperator.Split}`
        );
      }
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/payroll-concept.service.ts